<template>
  <teleport to="body">
    <transition name="backdrop" appear>
      <div class="backdrop" @click="$emit('close')" v-if="open">
      </div>
    </transition>
    <transition name="modal" appear>
      <div open v-if="open" class="base-dialog modal-dialog-centered">
        <dialog @keydown.esc="$emit('close')" :class="newClass">
          <a href="#" class="dialog-close" title="Close" @click.prevent="$emit('close')" v-if="showClose">
            <i class="fa fa-close"> </i>
          </a>
          <header v-if="title" class="dialog-header">
            <slot name="header">
              <div :class="titleClass">{{ title }}</div>
            </slot>
          </header>
          <section class='dialog-body'>
            <slot></slot>
          </section>
          <section class="actions">
            <slot name="actions">
              <button @click="$emit('close')" class="btn btn-sm btn-primary">Close</button>
            </slot>
          </section>
        </dialog>
      </div>
    </transition>
  </teleport>
</template>

<script>
export default {
    props: {
        open: {
            type: Boolean,
            required: true,
            default: false
        },
        title: {
            type: String,
            required: false,
        },
        titleClass: {
            type: String,
            default: 'card-title'
        },
        showClose: {
            type: Boolean,
            default: true
        },
        newClass: {
            type: String,
        },
    },
    emits: ['close'],
};
</script>

<style scoped>
.dialog-header{
  margin-right: 20px;  
}

.base-dialog{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    padding: 0.5rem;
}

/* dialog */
dialog {
	position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  /* width: 100%; */
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}


header {
  position: relative;
}

header .card-title {
  min-height: 45px;
}

.dialog-close {
  height: 40px;
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
  z-index: 2;
}

.dialog-close:before, 
.dialog-close:after {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 2px;
    height: 15px;
    background-color: #2c3e50;
    transform: rotate(45deg) translate(-50%, -50%);
    transform-origin: top left;
    transition: all 420ms;
    content: '';
}

.dialog-close:after {
    transform: rotate(-45deg) translate(-50%, -50%);
}

.backdrop {
  content: '';
  position: absolute;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 998;
  background: rgba(51, 51, 51, 0.8);
  opacity: 0.6;
  cursor: pointer;
}

.backdrop-enter-active {
  animation: backdrop ease .4s;
}

.backdrop-leave-active {
  animation: backdrop ease .4s reverse;
}

@keyframes backdrop {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.6;
  }
}

.modal-enter-active {
  animation: modal 0.3s ease-out;
}

.modal-leave-active {
  animation: modal 0.3s ease-in reverse;
}

@keyframes modal {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.9);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.actions {
  display: flex;
  -webkit-box-pack: end;
  justify-content: flex-end;
  margin-top: 2rem;
  text-align: right;
}

[dir=ltr] .actions > *:not(:last-child) {
  margin-right: 12px;
}

</style>